<script>
import { mapGetters } from 'vuex';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cancel', 'update:show'],
  data() {
    return {
      isDirty: false,
      isClosing: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
  },

  methods: {
    onDirtyChange(value) {
      this.isDirty = value;
    },
    async onCancel() {
      if (this.isClosing) return;
      if (!this.isDirty) {
        this.$emit('cancel');
        return;
      }
      this.isClosing = true;
      try {
        const shouldSave =
          await this.$refs.unsavedChangesDialog.showConfirmation();
        if (shouldSave) {
          await this.$refs.contactForm.submit();
        } else {
          this.$emit('cancel');
        }
      } finally {
        this.isClosing = false;
      }
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      await this.$store.dispatch('contacts/update', contactItem);
      await this.$store.dispatch(
        'contacts/fetchContactableInbox',
        this.contact.id
      );
    },
  },
};
</script>

<template>
  <div>
    <woot-modal
      v-model:show="localShow"
      @close="onCancel"
      modal-type="right-aligned"
    >
      <div class="flex flex-col h-auto overflow-auto">
        <woot-modal-header
          :header-title="`${$t('EDIT_CONTACT.TITLE')} - ${
            contact.name || contact.email
          }`"
          :header-content="$t('EDIT_CONTACT.DESC')"
        />
        <ContactForm
          ref="contactForm"
          :contact="contact"
          :in-progress="uiFlags.isUpdating"
          :on-submit="onSubmit"
          @success="onSuccess"
          @cancel="onCancel"
          @dirty-change="onDirtyChange"
        />
      </div>
    </woot-modal>
    <woot-confirm-modal
      ref="unsavedChangesDialog"
      :title="$t('CONTACT_FORM.FORM.UNSAVED_CHANGES.TITLE')"
      :description="$t('CONTACT_FORM.FORM.UNSAVED_CHANGES.DESCRIPTION')"
      :confirm-label="$t('CONTACT_FORM.FORM.UNSAVED_CHANGES.CONFIRM')"
      :cancel-label="$t('CONTACT_FORM.FORM.UNSAVED_CHANGES.CANCEL')"
    />
  </div>
</template>
